window.addEventListener('DOMContentLoaded', () => {
    let bars = document.querySelectorAll('.announcement-bar');
    let count = 0;
    function showBar() {
      if (document.documentElement.classList.contains('announcement-modal-open')) {
        setTimeout(showBar, 15000);
        return;
      }
      if(bars.length > 1) {
        bars.forEach(bar => {
          if(bar.querySelector('.announcement-bar__message') && bar.querySelector('.announcement-bar__message').innerText == '') {
            bar.remove();
            bars = document.querySelectorAll('.announcement-bar');
          }
          bar.classList.remove('show-bar');
          bars[count].classList.add('show-bar');
        })
        if(count == (bars.length - 1)) {
          count = 0;
        }else {
          count++;
        }
        setTimeout(showBar, 15000)
      }
    }
    showBar();
});